import { useState, useEffect } from 'react';

const ViewersNotification = () => {
  const [viewers, setViewers] = useState<number>(0);
  const [isVisible, setIsVisible] = useState(false);

  // Inicializar com número aleatório entre 8 e 34
  useEffect(() => {
    const initialViewers = Math.floor(Math.random() * (34 - 8 + 1)) + 8;
    setViewers(initialViewers);

    // Aparecer após 3-5 segundos
    const showDelay = Math.floor(Math.random() * (5000 - 3000 + 1)) + 3000;
    const showTimer = setTimeout(() => {
      setIsVisible(true);
    }, showDelay);

    return () => clearTimeout(showTimer);
  }, []);

  // Variar o número de visitantes a cada 20-45 segundos
  useEffect(() => {
    const updateViewers = () => {
      setViewers((prev) => {
        // Incremento/decremento suave entre -3 e +3
        const change = Math.floor(Math.random() * 7) - 3;
        const newValue = prev + change;
        
        // Manter entre 8 e 34
        if (newValue < 8) return 8;
        if (newValue > 34) return 34;
        
        return newValue;
      });
    };

    // Intervalo aleatório entre 20 e 45 segundos
    const getRandomInterval = () => Math.floor(Math.random() * (45000 - 20000 + 1)) + 20000;

    let intervalId: NodeJS.Timeout;

    const scheduleNextUpdate = () => {
      intervalId = setTimeout(() => {
        updateViewers();
        scheduleNextUpdate();
      }, getRandomInterval());
    };

    scheduleNextUpdate();

    return () => clearTimeout(intervalId);
  }, []);

  if (!isVisible) return null;

  return (
    <div
      className="fixed bottom-6 right-6 z-40 bg-white rounded-lg shadow-lg border border-gray-200 px-4 py-3 flex items-center gap-3 animate-fade-in"
      style={{
        animation: 'fadeIn 0.5s ease-in-out'
      }}
    >
      {/* Ponto verde pulsante */}
      <div className="relative flex items-center justify-center w-3 h-3">
        <span className="absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75 animate-ping"></span>
        <span className="relative inline-flex rounded-full h-3 w-3 bg-emerald-500"></span>
      </div>

      {/* Texto */}
      <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-gray-700">
          <span className="text-emerald-600 font-bold">{viewers}</span> pessoas estão vendo agora
        </span>
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default ViewersNotification;